export default __webpack_public_path__ + "static/media/destination-grid-320_385-Pachmarhi.5f4e79be.png";